import React from "react";
import axios from "axios";
import getMidwayToken from "../utils/getMidwayToken";
import jwtDecode from "jwt-decode";

const RECONCILIATION_TITLE = "Foaa Automation and Reporting Tools(FAART)"
axios.defaults.withCredentials = true;

export class HeaderBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        userId: "guest"
    }
  }

  componentDidMount() {
      console.log("Hello from the other side")
      getMidwayToken()
          .then(response => {
              console.log(jwtDecode(response).sub)
              this.setState({
                  userId: jwtDecode(response).sub
              })
          })
            .catch(error => {
                console.log("Something went wrong")
                console.log(error)
            })

    }

  render() {
    let isUserVisible = false
    let userLogin = ""


     userLogin = this.state.userId
     isUserVisible = true
     console.log(userLogin)


    let userPictureURL = "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" + userLogin
    const ttQuicklinkURL = "https://tt.amazon.com/quicklink/Q001010823"

    return (
      <header id="h" style={{ display: "flex", flexWrap: "nowrap", padding: "0", width: "100%", height: "57px", background: "#232f3e" }}>
        <div className="logo" style={{ paddingTop: "1.95rem", paddingLeft: "10px" }}>
          <a
            href="/"
            style={{ textDecoration: "none", fontWeight: "bold", cursor: "pointer", lineHeight: "16px", color: "#ffffff", fontSize: "2rem" }}
          >
            { RECONCILIATION_TITLE }
          </a>
        </div>
        <div className="header-icons" style={{ display: "flex", flexWrap: "nowrap", marginLeft: "auto" }}>
          <ul style={{ display: "flex", listStyle: "none" }}>
            <li style={{ paddingTop: "4%" }}>
              {isUserVisible && (
                <img
                  className="icon"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50px",
                    transform: "scale(0.73, 0.73)",
                    transformOrigin: "0 0",
                    borderStyle: "solid",
                    borderColor: "#ec7211",
                    borderWidth: "3px",
                  }}
                  src={userPictureURL}
                  alt={userLogin}
                />
              )}
            </li>
          </ul>
        </div>
      </header>
    )
  }
}

export default HeaderBar;


// WEBPACK FOOTER //
// ./src/components/HeaderBar.js